module.exports = __webpack_public_path__ + "6a1062de4a260c70545d422af9630372.svg";